<template>
    <div>
        <h3><strong style="color:#1A0054">Bootcamps</strong></h3>
        <div class="my-4 p-lg-5 p-md-5 p-sm-2 bg-white rounded">
            <div class="row px-5 py-3">
                <div class="col-lg-4 col-md-4 col-sm-12 rounded-8" v-for="bootcamp in bootcamps">
                    <div class="card rounded-8">
                        <img class="card-img-top" src="/images/preview_bootcamps.jpg" alt="Card image cap">
                        <div class="card-body">
                            <div class="mb-3">
                                <span class="badge badge-secondary text-primary bg-utel-v2-secondary">Bootcamp</span>
                                <span class="badge badge-secondary text-primary bg-utel-v2-secondary"><i class="fa fa-calendar" aria-hidden="true"></i> {{ getDuracion(bootcamp.program_time) }}</span>
                            </div>
                            <div class="text-card-normal mb-3">
                                <h5 class="card-title">{{ bootcamp.title }}</h5>
                                <p class="card-text">{{ bootcamp.description }}</p>
                            </div>
                            <div class="text-center">
                                <a href="https://wa.me/+5215592522981" target="_blank" class="btn bg-utel-v2-secondary text-primary sin-borde rounded-8 px-5">Ver más</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "urlbootcamps"
    ],
    data: function () {
        return {
            bootcamps: [],
            items_5_meses: [],
            items_8_meses: [],
            url: this.urlbootcamps
        }
    },
    mounted() {
        this.getBootcamps();
    },
    methods: {
        getBootcamps() {
            axios.get(this.url)
            .then((res) => {
                this.bootcamps = res.data;
                this.items_5_meses = this.bootcamps.filter((el) => el.program_time == '5_meses');
                this.items_8_meses = this.bootcamps.filter((el) => el.program_time == '8_meses');
            });
        },
        getDuracion(valor){
            let duracion = valor;
            duracion = duracion.replace("_", " ");
            return duracion;
        }
    }
}
</script>

<style>
.text-card-normal {
    font-size: 12px;
}
</style>